var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbedWiderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 400,
    height: 120,
    "aria-labelledby": titleId,
    viewBox: "0 0 400 120",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -9,
    rx: 0,
    ry: 0,
    width: 122,
    height: 130
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 5,
    rx: 0,
    ry: 0,
    width: 139,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 29,
    rx: 0,
    ry: 0,
    width: 107,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 54,
    rx: 0,
    ry: 0,
    width: 247,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 107,
    rx: 0,
    ry: 0,
    width: 37,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 108,
    rx: 0,
    ry: 0,
    width: 45,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 109,
    rx: 0,
    ry: 0,
    width: 39,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#9b99ff",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#b9b8ff",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#9b99ff",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedWiderIcon);
export default __webpack_public_path__ + "static/media/embed-wider-icon.b9d10c76.svg";
export { ForwardRef as ReactComponent };